import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigColumnDef } from './config-table.component';
import { ConfigurationService } from '../../../configuration/configuration.service';

interface DepotConfigRow {
  id: number;
  name: string;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  isMain: boolean;
  isActive: boolean;
  sortOrder: number | null;
}

@Component({
  selector: 'app-config-depots',
  template: `<app-config-table
    tableName="Depots"
    [columns]="columns"
    permissionKey="Config.Manage"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate">
  </app-config-table>`,
})
export class DepotConfigComponent {
  private readonly path = '/api/config/depots';

  readonly columns: ConfigColumnDef[] = [
    { field: 'name', label: 'Name', type: 'text', required: true, maxLength: 64 },
    { field: 'address', label: 'Address', type: 'text', maxLength: 255 },
    { field: 'latitude', label: 'Latitude', type: 'number' },
    { field: 'longitude', label: 'Longitude', type: 'number' },
    { field: 'isMain', label: 'Main', type: 'boolean' },
    { field: 'sortOrder', label: 'Sort Order', type: 'number' },
  ];

  constructor(private configuration: ConfigurationService) {
    this.load = () =>
      this.configuration.getConfigItems<DepotConfigRow>(this.path);
    this.create = data =>
      this.configuration.createConfigItem<DepotConfigRow>(this.path, data);
    this.update = (id, data) =>
      this.configuration.updateConfigItem<DepotConfigRow>(this.path, id, data);
    this.deactivate = id =>
      this.configuration.deactivateConfigItem(this.path, id);
  }

  load!: () => Observable<DepotConfigRow[]>;
  create!: (data: Partial<DepotConfigRow>) => Observable<DepotConfigRow>;
  update!: (
    id: number,
    data: Partial<DepotConfigRow>,
  ) => Observable<DepotConfigRow>;
  deactivate!: (id: number) => Observable<void>;
}
